// Library ▸ Home: the greeting, where you left off, the project against its target, this week and the year.
export { LibraryHomePage as component } from '../../views/Home.tsx';
export const room = 'library';
export const page = 'home';
export const title = 'Home';
export const help = 'rooms';
